import React, { createContext, useContext, useMemo, useState } from 'react'

// Contexte de langue pour la partie administration uniquement
export const AdminLanguageContext = createContext({
  lang: 'FR',
  setLang: () => {},
  t: (key) => key
})

// Dictionnaire minimal FR -> NL (nl-BE) pour l'administration
// Remarque: les données provenant du backend restent en FR
const TRANSLATIONS = {
  FR: {
    'FR': 'FR',
    'NL': 'NL',
    'BlueNote': 'BlueNote',
    'Déconnexion': 'Déconnexion',
    'Données zonales': 'Données zonales',
    // Menu principal
    'Accueil': 'Accueil',
    'Licence': 'Licence',
    "Message d'alerte": "Message d'alerte",
    'Utilisateurs': 'Utilisateurs',
    'Procès-verbaux': 'Procès-verbaux',
    'Rubriques': 'Rubriques',
    'Canevas de PV': 'Canevas de PV',
    'Préférences zonales': 'Préférences zonales',
    'Documents zonaux': 'Documents zonaux',
    'Annexes': 'Annexes',
    // Entités
    'Magistrats': 'Magistrats',
    'Hopitaux': 'Hôpitaux',
    'Dépanneurs': 'Dépanneurs',
    'Lieux de dépôt': 'Lieux de dépôt',
    'Implantations': 'Implantations',
    'Bourgmestres': 'Bourgmestres',
    'Médecins légistes': 'Médecins légistes',
    'Pompes funèbres': 'Pompes funèbres',
    'Prisons': 'Prisons',
    // Système
    'Gestion des données': 'Gestion des données',
    'Journalisation': 'Journalisation',
    'Accès administration': 'Accès administration',
    // Home
    "Espace d'administration de BlueNote": "Espace d'administration de BlueNote",
    'Chargement...': 'Chargement...',
    'Version': 'Version',
    "Vue d'ensemble du système": "Vue d'ensemble du système",
    'Documents': 'Documents',
    'PV canevas': 'PV canevas',
    'État de la licence': 'État de la licence',
    'Licence expirée': 'Licence expirée',
    'Contactez le support pour renouveler': 'Contactez le support pour renouveler',
    'Licence active': 'Licence active',
    'Expire dans {days} jours': 'Expire dans {days} jours',
    'Renouvellement recommandé': 'Renouvellement recommandé',
    'Données de référence': 'Données de référence',
    'Suppression auto après {days} jours': 'Suppression auto après {days} jours',
    'Conservation indéfinie': 'Conservation indéfinie',
    "Besoin d'aide ?": "Besoin d'aide ?",
    'Gestion des Annexes': 'Gestion des Annexes',
    'Modifier l\'annexe': 'Modifier l\'annexe',
    'Ajouter une annexe': 'Ajouter une annexe',
    'Liste des Annexes': 'Liste des Annexes',
    'Description': 'Description',
    'Aucune annexe trouvée': 'Aucune annexe trouvée',
    'Êtes-vous sûr de vouloir supprimer cette annexe ?': 'Êtes-vous sûr de vouloir supprimer cette annexe ?',
  },
  NL: {
    'FR': 'FR',
    'NL': 'NL',
    'BlueNote': 'BlueNote',
    'Déconnexion': 'Afmelden',
    'Données zonales': 'Zonale gegevens',
    // Menu principal
    'Accueil': 'Start',
    'Licence': 'Licentie',
    "Message d'alerte": 'Waarschuwingsbericht',
    'Utilisateurs': 'Gebruikers',
    'Procès-verbaux': 'Proces-verbalen',
    'Rubriques': 'Rubrieken',
    'Canevas de PV': 'PV-sjablonen',
    'Préférences zonales': 'Zonale voorkeuren',
    'Documents zonaux': 'Zonale documenten',
    'Annexes': 'Bijlagen',
    // Entités
    'Magistrats': 'Magistraten',
    'Hopitaux': 'Ziekenhuizen',
    'Dépanneurs': 'Takeldiensten',
    'Lieux de dépôt': 'Bewaarplaatsen',
    'Implantations': 'Vestigingen',
    'Bourgmestres': 'Burgemeesters',
    'Médecins légistes': 'Gerechtsartsen',
    'Pompes funèbres': 'Begrafenisondernemers',
    'Prisons': 'Gevangenissen',
    // Système
    'Gestion des données': 'Gegevensbeheer',
    'Journalisation': 'Logboek',
    'Accès administration': 'Beheer-toegang',
    // Home
    "Espace d'administration de BlueNote": 'BlueNote-beheeromgeving',
    'Chargement...': 'Laden...',
    'Version': 'Versie',
    "Vue d'ensemble du système": 'Systeemoverzicht',
    'Documents': 'Documenten',
    'PV canevas': 'PV-sjablonen',
    'État de la licence': 'Licentiestatus',
    'Licence expirée': 'Licentie verlopen',
    'Contactez le support pour renouveler': 'Neem contact op met support voor verlenging',
    'Licence active': 'Licentie actief',
    'Expire dans {days} jours': 'Verloopt binnen {days} dagen',
    'Renouvellement recommandé': 'Vernieuwing aanbevolen',
    'Données de référence': 'Referentiegegevens',
    'Suppression auto après {days} jours': 'Automatische verwijdering na {days} dagen',
    'Conservation indéfinie': 'Onbeperkte bewaring',
    "Besoin d'aide ?": 'Hulp nodig?',
    // Info.js - body content keys (FR → NL)
    'Cette page vous permet de gérer la liste des magistrats. Vous pouvez ajouter, modifier et supprimer des magistrats de la liste.': 'Op deze pagina beheert u de lijst met magistraten. U kunt magistraten toevoegen, wijzigen en verwijderen.',
    'Cette liste est utilisée dans les rubriques génératives. Veillez donc à ce que la liste soit à jour.': 'Deze lijst wordt gebruikt in generatieve rubrieken. Zorg ervoor dat de lijst up-to-date is.',
    'Cette page vous permet de gérer la liste des implantations de votre zone. Vous pouvez ajouter, modifier et supprimer des implantations de la liste.': 'Op deze pagina beheert u de vestigingen van uw zone. U kunt vestigingen toevoegen, wijzigen en verwijderen.',
    'Cette page vous permet de gérer la liste des procès-verbaux.': 'Op deze pagina beheert u de lijst van proces-verbalen.',
    "Vous pouvez restreindre l'accès à un procès-verbal et le limiter à un groupe d'utilisateurs.": 'U kunt de toegang tot een proces-verbaal beperken tot een groep gebruikers.',
    "Vous pouvez également supprimer un procès-verbal. Il n'existe plus de moyens de récupérer un procès-verbal supprimé.": 'U kunt ook een proces-verbaal verwijderen. Een verwijderd proces-verbaal kan niet worden hersteld.',
    "Au cas où un utilisateur aurait réservé un procès-verbal par mégarde, vous pouvez le supprimer ici afin qu'il puisse être à nouveau généré.": 'Indien een gebruiker per vergissing een proces-verbaal heeft gereserveerd, kunt u het hier verwijderen zodat het opnieuw kan worden gegenereerd.',
    'Cette page vous permet de gérer la liste des rubriques que votre personnel pourra utiliser.': 'Op deze pagina beheert u de rubrieken die uw personeel kan gebruiken.',
    'Il existe deux types de rubriques : les rubriques de type "Générative" et les rubriques de type "Manuelle".': 'Er zijn twee soorten rubrieken: “Generatief” en “Handmatig”.',
    "Les rubriques de type 'Générative' sont des rubriques qui vont nécessiter des informations fournies par l'utilisateur pour se générer.": 'Generatieve rubrieken hebben door de gebruiker aangeleverde informatie nodig om te worden gegenereerd.',
    'Ces rubriques sont plus complexes et requièrent un fichier extérieur. Pour développer une nouvelle rubrique de type "Générative", prenez contact avec l\'adresse mail suivante : contact@pyll.be.': 'Deze rubrieken zijn complexer en vereisen een extern bestand. Voor een nieuwe generatieve rubriek, neem contact op via: contact@pyll.be.',
    'Les rubriques de type "Manuelle" sont des rubriques simples qui générent un texte prédéfini. Vous pouvez en créer autant que vous le souhaitez.': 'Handmatige rubrieken genereren een vooraf bepaalde tekst. U kunt er zoveel maken als u wilt.',
    'etc': 'enz.',
    'Cette page vous permet de gérer la liste des canevas. Vous pouvez ajouter, modifier et supprimer des canevas de la liste.': 'Op deze pagina beheert u de sjablonen. U kunt sjablonen toevoegen, wijzigen en verwijderen.',
    'Cette page vous permet de gérer la liste des utilisateurs. Vous pouvez ajouter, modifier et supprimer des utilisateurs de la liste.': 'Op deze pagina beheert u de gebruikers. U kunt gebruikers toevoegen, wijzigen en verwijderen.',
    'Cette page vous permet de gérer les données propres à votre zone. Vos préférences et spécificités sont configurées ici.': 'Op deze pagina beheert u de gegevens van uw zone. Uw voorkeuren en specificiteiten worden hier ingesteld.',
    'Mettez à jour ces données en cliquant sur le bouton "Modifier" en bas de page.': 'Werk deze gegevens bij door onderaan op “Wijzigen” te klikken.',
    'Cette page vous permet de gérer votre licence BlueNote.': 'Op deze pagina beheert u uw BlueNote-licentie.',
    "Vous pouvez voir l'état actuel de votre licence et la durée restante avant le blocage de l'application.": 'U ziet de huidige status van uw licentie en de resterende tijd voor blokkering van de applicatie.',
    'Veillez à bien mettre à jour votre licence avant son expiration. Pour cela, copiez la clef produit dans son entièreté, collez-la dans le champ ci-dessous et cliquez sur "Enregistrer la clef".': 'Werk uw licentie tijdig bij. Kopieer de volledige productsleutel, plak die hieronder en klik op “Sleutel opslaan”.',
    "Pour obtenir une nouvelle licence, prenez contact avec l'adresse e-mail suivante : contact@pyll.be": 'Voor een nieuwe licentie, contacteer: contact@pyll.be',
    "Cette page vous permet de visualiser la journalisation de l'application.": 'Op deze pagina bekijkt u het logboek van de applicatie.',
    "Cette page vous permet de changer le mot de passe d'administration.": 'Op deze pagina wijzigt u het beheerderswachtwoord.',
    'Indiquez votre mot de passe actuel, le nouveau mot de passe et confirmez le nouveau mot de passe.': 'Vul uw huidige wachtwoord, het nieuwe wachtwoord in en bevestig het nieuwe wachtwoord.',
    'Cette page vous permet de gérer les dépanneurs agréés au sein de votre zone. Vous pouvez ajouter, modifier et supprimer des dépanneurs de la liste.': 'Op deze pagina beheert u de erkende takeldiensten van uw zone. U kunt ze toevoegen, wijzigen en verwijderen.',
    'Cette page est utilisée dans les rubriques génératives. Veillez donc à ce que la liste soit à jour.': 'Deze pagina wordt gebruikt in generatieve rubrieken. Zorg ervoor dat de lijst up-to-date is.',
    'Cette page vous permet de gérer les hôpitaux de votre zone. Vous pouvez ajouter, modifier et supprimer des hôpitaux de la liste.': 'Op deze pagina beheert u de ziekenhuizen in uw zone. U kunt ze toevoegen, wijzigen en verwijderen.',
    'Cette page vous permet de gérer les lieux de dépôt de votre zone. Vous pouvez ajouter, modifier et supprimer des lieux de dépôt de la liste.': 'Op deze pagina beheert u de bewaarplaatsen in uw zone. U kunt ze toevoegen, wijzigen en verwijderen.',
    'Chaque lieu de dépôt est identifié par un préfixe et une adresse précise. Cette liste est utilisée dans les rubriques génératives.': 'Elke bewaarplaats wordt geïdentificeerd door een voorvoegsel en een exact adres. Deze lijst wordt gebruikt in generatieve rubrieken.',
    'Veillez donc à ce que la liste soit à jour et que les informations soient correctes.': 'Zorg er dus voor dat de lijst up-to-date is en de informatie correct is.',
    'Cette page vous permet de gérer les bourgmestres de votre zone. Vous pouvez ajouter, modifier et supprimer des bourgmestres de la liste.': 'Op deze pagina beheert u de burgemeesters van uw zone. U kunt ze toevoegen, wijzigen en verwijderen.',
    'Chaque bourgmestre est identifié par son nom, prénom, sexe, statut F.F. et commune liée. Cette liste est utilisée dans les rubriques génératives.': 'Elke burgemeester wordt geïdentificeerd door naam, voornaam, geslacht, F.F.-status en gekoppelde gemeente. Deze lijst wordt gebruikt in generatieve rubrieken.',
    'Cette page vous permet de gérer les pompes funèbres de votre zone. Vous pouvez ajouter, modifier et supprimer des pompes funèbres de la liste.': 'Op deze pagina beheert u de begrafenisondernemers van uw zone. U kunt ze toevoegen, wijzigen en verwijderen.',
    "Chaque pompe funèbre est identifiée par son nom d'exploitation. Cette liste est utilisée dans les rubriques génératives.": 'Elke begrafenisondernemer wordt geïdentificeerd door de exploitantnaam. Deze lijst wordt gebruikt in generatieve rubrieken.',
    'Cette page vous permet de gérer les médecins légistes de votre zone. Vous pouvez ajouter, modifier et supprimer des médecins légistes de la liste.': 'Op deze pagina beheert u de gerechtsartsen van uw zone. U kunt ze toevoegen, wijzigen en verwijderen.',
    'Chaque médecin légiste est identifié par son nom et prénom. Cette liste est utilisée dans les rubriques génératives.': 'Elke gerechtsarts wordt geïdentificeerd door naam en voornaam. Deze lijst wordt gebruikt in generatieve rubrieken.',
    'Cette page vous permet de gérer les prisons de votre zone. Vous pouvez ajouter, modifier et supprimer des prisons de la liste.': 'Op deze pagina beheert u de gevangenissen van uw zone. U kunt ze toevoegen, wijzigen en verwijderen.',
    'Chaque prison est identifiée par son nom et son adresse. Cette liste est utilisée dans les rubriques génératives.': 'Elke gevangenis wordt geïdentificeerd door naam en adres. Deze lijst wordt gebruikt in generatieve rubrieken.',
    // Info title
    'Informations': 'Informatie',
    "Notre équipe support est disponible pour vous accompagner dans l'utilisation de BlueNote.": 'Ons supportteam staat klaar om u te begeleiden bij het gebruik van BlueNote.',
    "Que ce soit pour des questions techniques, des demandes de nouvelles fonctionnalités ou le renouvellement de votre licence, nous sommes là pour vous aider.": 'Voor technische vragen, verzoeken om nieuwe functies of vernieuwing van uw licentie: wij helpen u graag verder.',
    "Contactez-nous à l'adresse suivante en mentionnant votre version de BlueNote :": 'Contacteer ons op volgend adres en vermeld uw BlueNote-versie:',
    // Commun actions/labels
    'Ajouter': 'Toevoegen',
    'Modifier': 'Wijzigen',
    'Annuler': 'Annuleren',
    'Enregistrer': 'Opslaan',
    'Enregistrement...': 'Opslaan...',
    'Actions': 'Acties',
    'Supprimer': 'Verwijderen',
    'Confirmer la suppression': 'Verwijderen bevestigen',
    "Êtes-vous sûr de vouloir supprimer l'utilisateur": 'Weet u zeker dat u de gebruiker wilt verwijderen',
    'Cette action est irréversible.': 'Deze handeling is onomkeerbaar.',
    'Fermer': 'Sluiten',
    'Public': 'Publiek',
    'Accès restreint': 'Beperkte toegang',
    // Commun champs
    'Nom': 'Naam',
    'Prénom': 'Voornaam',
    'Adresse': 'Adres',
    'Matricule': 'Stamnummer',
    'Grade': 'Graad',
    'Service': 'Dienst',
    'Sexe': 'Geslacht',
    'Langue': 'Taal',
    'Couleur': 'Kleur',
    'OPJ ?': 'OGP?',
    'OPA ?': 'OBP?',
    'Modérateur ?': 'Moderator?',
    'Statut': 'Status',
    'Actif': 'Actief',
    'Bloqué': 'Geblokkeerd',
    'Oui': 'Ja',
    'Non': 'Nee',
    'M': 'M',
    'F': 'V',
    'Français': 'Frans',
    'Néerlandais': 'Nederlands',
    'Mot de passe': 'Wachtwoord',
    'Premier (13 ans)': 'Eerste (13 jaar)',
    'Qualité OPJ': 'Kwaliteit OGP',
    'Qualité OPA': 'Kwaliteit OBP',
    'Modérateur': 'Moderator',
    'Rechercher': 'Zoeken',
    // Language selector
    'Langue de travail': 'Werktaal',
    'Sélectionnez la version linguistique à administrer': 'Selecteer de te beheren taalversie',
    'Version française': 'Franse versie',
    'Version néerlandaise': 'Nederlandse versie',
    // Titres pages
    'Gestion des utilisateurs': 'Gebruikersbeheer',
    'Gestion des procès-verbaux': 'Beheer van proces-verbalen',
    'Gestion des rubriques': 'Beheer van rubrieken',
    'Gestion des Canevas': 'Beheer van PV-sjablonen',
    'Gestion des Magistrats': 'Beheer van magistraten',
    'Gestion des Hôpitaux': 'Beheer van ziekenhuizen',
    'Gestion des dépanneurs': 'Beheer van takeldiensten',
    'Gestion des lieux de dépôt': 'Beheer van bewaarplaatsen',
    'Gestion des Implantations': 'Beheer van vestigingen',
    'Gestion des bourgmestres': 'Beheer van burgemeesters',
    'Gestion des prisons': 'Beheer van gevangenissen',
    'Gestion des médecins légistes': 'Beheer van gerechtsartsen',
    'Gestion des pompes funèbres': 'Beheer van begrafenisondernemers',
    'Gestion des documents zonaux': 'Beheer van zonale documenten',
    'Gestion des données': 'Gegevensbeheer',
    'Gestion des licences': 'Licentiebeheer',
    // Listes et libellés
    'Liste des utilisateurs': 'Lijst van gebruikers',
    'Rechercher un utilisateur': 'Zoek een gebruiker',
    'Matricule, grade, nom ou prénom': 'Stamnummer, graad, naam of voornaam',
    'Liste des rubriques': 'Lijst van rubrieken',
    'Liste des hôpitaux': 'Lijst van ziekenhuizen',
    'Liste des dépanneurs': 'Lijst van takeldiensten',
    'Liste des lieux de dépôt': 'Lijst van bewaarplaatsen',
    'Liste des prisons': 'Lijst van gevangenissen',
    'Liste des pompes funèbres': 'Lijst van begrafenisondernemers',
    'Liste des Canevas': 'Lijst van PV-sjablonen',
    'Liste des magistrats': 'Lijst van magistraten',
    'Rechercher une rubrique': 'Rubriek zoeken',
    'Version ou titre de rubrique': 'Versie of titel van rubriek',
    'Identifiant': 'Identificatie',
    'Titre': 'Titel',
    'Nombre de rubriques': 'Aantal rubrieken',
    'Type': 'Type',
    'Catégories': 'Categorieën',
    'Visible': 'Zichtbaar',
    'Cachée': 'Verborgen',
    'Rendre visible': 'Zichtbaar maken',
    'Cacher': 'Verbergen',
    // ReportAdmin
    'Rechercher un procès-verbal': 'Zoek een proces-verbaal',
    'Numéro, année, indice ou créateur': 'Nummer, jaar, index of opsteller',
    'Indice': 'Index',
    'Numéro': 'Nummer',
    'Année': 'Jaar',
    'Créateur': 'Opsteller',
    'Date de création': 'Aanmaakdatum',
    'Accès': 'Toegang',
    'Accès restreint': 'Beperkte toegang',
    'Utilisateurs autorisés': 'Toegelaten gebruikers',
    'Public': 'Publiek',
    'Non restreint': 'Onbeperkt',
    'Restreint ({count} utilisateurs)': 'Beperkt ({count} gebruikers)',
    // Standard/Rubric
    'Ajouter un Canevas': 'Sjabloon toevoegen',
    'Modifier le Canevas': 'Sjabloon wijzigen',
    'Identifiant technique': 'Technisch ID',
    'Placer après': 'Plaatsen na',
    'Début de la liste': 'Begin van de lijst',
    'Mots-clés pour la recherche': 'Trefwoorden voor de zoekfunctie',
    'Ajouter un mot-clé': 'Trefwoord toevoegen',
    'Sélectionner les rubriques': 'Rubrieken selecteren',
    'Sélectionnée': 'Geselecteerd',
    'Sélectionner': 'Selecteren',
    'Aucune rubrique sélectionnée. Cliquez sur "Sélectionner les rubriques" pour en ajouter.': 'Geen rubriek geselecteerd. Klik op "Rubrieken selecteren" om toe te voegen.',
    // Place
    "Modifier l'implantation": 'Vestiging wijzigen',
    'Ajouter une implantation': 'Vestiging toevoegen',
    'Liste des implantations': 'Lijst van vestigingen',
    // Mayor
    'Modifier le bourgmestre': 'Burgemeester wijzigen',
    'Ajouter un bourgmestre': 'Burgemeester toevoegen',
    'Liste des bourgmestres': 'Lijst van burgemeesters',
    'Sexe': 'Geslacht',
    'Commune liée': 'Verbonden gemeente',
    'Masculin': 'Mannelijk',
    'Féminin': 'Vrouwelijk',
    // Magistrat
    'Modifier le magistrat': 'Magistraat wijzigen',
    'Ajouter un magistrat': 'Magistraat toevoegen',
    'Préfixe + Parquet (ex : près le Parquet de..)': 'Voorvoegsel + Parket (bv.: bij het parket van..)',
    'Genre': 'Geslacht',
    "Juge d'Instruction": 'Onderzoeksrechter',
    // Jail
    'Modifier la prison': 'Gevangenis wijzigen',
    'Ajouter une prison': 'Gevangenis toevoegen',
    'Nom de la prison': 'Naam van de gevangenis',
    // Funeral
    'Modifier la pompe funèbre': 'Begrafenisondernemer wijzigen',
    'Ajouter une pompe funèbre': 'Begrafenisondernemer toevoegen',
    "Nom d'exploitation": 'Exploitantnaam',
    // Hospital
    "Modifier l'hôpital": 'Ziekenhuis wijzigen',
    'Ajouter un hôpital': 'Ziekenhuis toevoegen',
    // Garage
    'Modifier le dépanneur': 'Takeldienst wijzigen',
    'Ajouter un dépanneur': 'Takeldienst toevoegen',
    // DropOff
    'Modifier le lieu de dépôt': 'Bewaarplaats wijzigen',
    'Ajouter un lieu de dépôt': 'Bewaarplaats toevoegen',
    'Préfixe (ex : entre les mains du, auprès de, chez, au)': 'Voorvoegsel (bv.: in handen van, bij, bij, in)',
    'Préfixe': 'Voorvoegsel',
    'Lieu de dépôt': 'Bewaarplaats',
    // Examiner
    'Modifier le médecin légiste': 'Gerechtsarts wijzigen',
    'Ajouter un médecin légiste': 'Gerechtsarts toevoegen',
    'Liste des médecins légistes': 'Lijst van gerechtsartsen',
    'Liste des documents': 'Lijst van documenten',
    'Rechercher un document': 'Zoek een document',
    'Titre du document': 'Documenttitel',
    'Modifier le document': 'Document wijzigen',
    'Ajouter un document': 'Document toevoegen',
    'Choisir un fichier': 'Bestand kiezen',
    'Changer le fichier (optionnel)': 'Bestand wijzigen (optioneel)',
    'Télécharger': 'Downloaden',
    'Êtes-vous sûr de vouloir supprimer ce document ?': 'Weet u zeker dat u dit document wilt verwijderen?',
    'Le titre est obligatoire': 'De titel is verplicht',
    'Le fichier est obligatoire': 'Het bestand is verplicht',
    'Seuls les fichiers PDF et DOCX sont acceptés': 'Alleen PDF- en DOCX-bestanden worden geaccepteerd',
    'Document mis à jour avec succès': 'Document succesvol bijgewerkt',
    'Document ajouté avec succès': 'Document succesvol toegevoegd',
    'Document supprimé avec succès': 'Document succesvol verwijderd',
    'Erreur lors du chargement des documents': 'Fout bij het laden van documenten',
    'Erreur lors de l\'enregistrement du document': 'Fout bij het opslaan van het document',
    'Erreur lors de la suppression du document': 'Fout bij het verwijderen van het document',
    'Erreur lors du téléchargement': 'Fout bij het downloaden',
    'Homme': 'Man',
    'Femme': 'Vrouw',
    // License
    'Gestion des licences': 'Licentiebeheer',
    'État de la licence actuelle': 'Huidige licentiestatus',
    "Date d'expiration": 'Vervaldatum',
    'Jours restants': 'Resterende dagen',
    'Clef produit': 'Productsleutel',
    'Enregistrer la clef': 'Sleutel opslaan',
    'Active': 'Actief',
    'Expirée': 'Verlopen',
    'Expire bientôt': 'Verloopt binnenkort',
    // LogFile
    'Journalisation (Logs)': 'Logboek',
    'Filtres': 'Filters',
    'Actualiser': 'Vernieuwen',
    'Exporter': 'Exporteren',
    'Réinitialiser filtres': 'Filters resetten',
    'Catégorie': 'Categorie',
    'Sévérité': 'Ernst',
    'Date début': 'Begindatum',
    'Date fin': 'Einddatum',
    'N° Rapport': 'Verslagnr.',
    'Date/Heure': 'Datum/Tijd',
    'Action': 'Actie',
    'Utilisateur': 'Gebruiker',
    'Détails': 'Details',
    'Chargement...': 'Laden...',
    'Aucun log trouvé': 'Geen log gevonden',
    'Détails du log': 'Logdetails',
    'Localisation': 'Locatie',
    'Tous les résultats sont affichés sur cette page': 'Alle resultaten staan op deze pagina',
    // DataAdmin
    'Résumé de la configuration': 'Overzicht van de configuratie',
    'Sauvegarde en cours...': 'Bezig met bewaren...',
    'Sauvegarder les paramètres': 'Instellingen bewaren',
    'Logs de connexion': 'Aanmeldingslogs',
    'Période de conservation': 'Bewaarperiode',
    'Nombre de jours personnalisé': 'Aangepast aantal dagen',
    'Entrez un nombre de jours personnalisé si les options prédéfinies ne conviennent pas': 'Voer een aangepast aantal dagen in als de vooraf ingestelde opties niet volstaan',
    'Suppression automatique après {days} jours': 'Automatische verwijdering na {days} dagen',
    // DataAdmin durations
    '30 jours (1 mois)': '30 dagen (1 maand)',
    '90 jours (3 mois)': '90 dagen (3 maanden)',
    '180 jours (6 mois)': '180 dagen (6 maanden)',
    '365 jours (1 an)': '365 dagen (1 jaar)',
    '730 jours (2 ans)': '730 dagen (2 jaar)',
    '1095 jours (3 ans)': '1095 dagen (3 jaar)',
    '1825 jours (5 ans)': '1825 dagen (5 jaar)',
    '3650 jours (10 ans)': '3650 dagen (10 jaar)',
    'Supprimer automatiquement les procès-verbaux': 'Proces-verbalen automatisch verwijderen',
    'Les procès-verbaux seront supprimés automatiquement après la période définie.': 'Proces-verbalen worden automatisch verwijderd na de ingestelde periode.',
    'Les procès-verbaux sont conservés indéfiniment.': 'Proces-verbalen worden onbeperkt bewaard.',
    'Supprimer automatiquement les logs': 'Logs automatisch verwijderen',
    'Les logs de connexion seront supprimés automatiquement après la période définie.': 'Aanmeldingslogs worden automatisch verwijderd na de ingestelde periode.',
    'Les logs de connexion sont conservés indéfiniment.': 'Aanmeldingslogs worden onbeperkt bewaard.',
    // ZonalAdmin
    'Préférences Zonales': 'Zonale voorkeuren',
    'Données Communes': 'Gemeenschappelijke gegevens',
    'Données Multilingues': 'Meertalige gegevens',
    'Version en français': 'Franstalige versie',
    'Version en néerlandais': 'Nederlandstalige versie'
    ,
    // Zonal fields
    'N° de Client': 'Klantnr.',
    'Nom de Client': 'Klantnaam',
    'Version de BlueNote': 'BlueNote-versie',
    'Type': 'Type',
    'Locale': 'Lokaal',
    'Fédérale': 'Federaal',
    'Numéro de la Zone': 'Zonenummer',
    'Arrondissement Judiciaire (Court)': 'Gerechtelijk arrondissement (kort)',
    'N° de Division Judiciaire': 'Rechterlijke afdeling nr.',
    'Nom de la Zone': 'Naam van de zone',
    'Adresse de la Zone': 'Adres van de zone',
    'Arrondissement Judiciaire': 'Gerechtelijk arrondissement',
    'Nom de Zone dans les Procès-Verbaux': 'Zonenaam in de PV’s',
    'Nom du dispatching': 'Naam van de dispatching',
    'Service dépôt pièces à conviction': 'Dienst opslag inbeslaggenomen goederen',
    'Nom du chef de corps': 'Korpschef',
    'Lieu de rédaction par défaut': 'Standaard opstellingsplaats',
    'Nom du CPVS': 'Naam van het CPVS',
    'Lieu du CPVS': 'Plaats van het CPVS',
    'Nom de la Zone (NL)': 'Naam van de zone (NL)',
    // AdminAccess
    'Comptes administrateur': 'Beheerdersaccounts',
    'Connecté :': 'Aangemeld:',
    'Ajouter un compte administrateur': 'Beheerdersaccount toevoegen',
    'Liste des comptes administrateur': 'Lijst van beheerdersaccounts',
    'au total': 'in totaal',
    '9 chiffres': '9 cijfers',
    'Confirmation': 'Bevestiging',
    'Changer mon mot de passe': 'Mijn wachtwoord wijzigen',
    'Modifier le mot de passe': 'Wachtwoord wijzigen',
    'Modifier le mot de passe du compte': 'Wachtwoord wijzigen van account',
    'Les sessions ouvertes avec ce compte seront fermées. Communiquez le nouveau mot de passe à son titulaire.': 'De sessies die met dit account geopend zijn, worden afgesloten. Bezorg het nieuwe wachtwoord aan de houder van het account.',
    'Mot de passe du compte administrateur mis à jour.': 'Wachtwoord van het beheerdersaccount bijgewerkt.',
    'Utilisez « Changer mon mot de passe » pour modifier votre propre mot de passe.': 'Gebruik « Mijn wachtwoord wijzigen » om uw eigen wachtwoord te wijzigen.',
    'Mot de passe actuel': 'Huidig wachtwoord',
    'Nouveau mot de passe': 'Nieuw wachtwoord',
    'Confirmer le nouveau mot de passe': 'Nieuw wachtwoord bevestigen',
    'Dernière modification': 'Laatste wijziging',
    'Vous': 'Uw account',
    'Compte initial': 'Initieel account',
    'Vous ne pouvez pas supprimer votre propre compte': 'U kunt uw eigen account niet verwijderen',
    'Êtes-vous sûr de vouloir supprimer le compte administrateur': 'Weet u zeker dat u het beheerdersaccount wilt verwijderen',
    "Le compte initial 000000000 est toujours actif. Créez votre propre compte administrateur, connectez-vous avec celui-ci puis supprimez le compte initial.": 'Het initiële account 000000000 is nog steeds actief. Maak uw eigen beheerdersaccount aan, meld u daarmee aan en verwijder vervolgens het initiële account.',
    'Au moins 8 caractères, dont une majuscule, une minuscule, un chiffre et un caractère spécial.': 'Minstens 8 tekens, waaronder een hoofdletter, een kleine letter, een cijfer en een speciaal teken.',
    'Mot de passe : au moins 8 caractères, dont une majuscule, une minuscule, un chiffre et un caractère spécial.': 'Wachtwoord: minstens 8 tekens, waaronder een hoofdletter, een kleine letter, een cijfer en een speciaal teken.',
    'Le matricule doit comporter exactement 9 chiffres.': 'Het stamnummer moet uit precies 9 cijfers bestaan.',
    'Les mots de passe ne correspondent pas.': 'De wachtwoorden komen niet overeen.',
    'Les nouveaux mots de passe ne correspondent pas.': 'De nieuwe wachtwoorden komen niet overeen.',
    'Le mot de passe doit contenir au moins 8 caractères.': 'Het wachtwoord moet minstens 8 tekens bevatten.',
    'Le mot de passe est trop long (72 octets maximum).': 'Het wachtwoord is te lang (maximaal 72 bytes).',
    'Le mot de passe doit contenir au moins une minuscule, une majuscule, un chiffre et un caractère spécial.': 'Het wachtwoord moet minstens een kleine letter, een hoofdletter, een cijfer en een speciaal teken bevatten.',
    "Le nouveau mot de passe doit être différent de l'actuel.": 'Het nieuwe wachtwoord moet verschillen van het huidige.',
    'Le mot de passe actuel est incorrect.': 'Het huidige wachtwoord is onjuist.',
    'Un compte administrateur existe déjà pour ce matricule.': 'Er bestaat al een beheerdersaccount voor dit stamnummer.',
    'Vous ne pouvez pas supprimer votre propre compte. Connectez-vous avec un autre compte administrateur pour le faire.': 'U kunt uw eigen account niet verwijderen. Meld u hiervoor aan met een ander beheerdersaccount.',
    'Compte administrateur introuvable.': 'Beheerdersaccount niet gevonden.',
    'Compte administrateur créé avec succès.': 'Beheerdersaccount succesvol aangemaakt.',
    'Compte administrateur supprimé.': 'Beheerdersaccount verwijderd.',
    'Mot de passe mis à jour avec succès.': 'Wachtwoord succesvol bijgewerkt.',
    'Erreur lors du chargement des comptes administrateur.': 'Fout bij het laden van de beheerdersaccounts.',
    'Erreur lors de la création du compte administrateur.': 'Fout bij het aanmaken van het beheerdersaccount.',
    'Erreur lors de la suppression du compte administrateur.': 'Fout bij het verwijderen van het beheerdersaccount.',
    'Erreur lors de la mise à jour du mot de passe.': 'Fout bij het bijwerken van het wachtwoord.',
    'Une erreur est survenue lors de la communication avec le serveur.': 'Er is een fout opgetreden bij de communicatie met de server.',
    'Accès réservé aux administrateurs': 'Toegang voorbehouden aan beheerders',
    'Session administrateur invalide ou expirée. Veuillez vous reconnecter.': 'Ongeldige of verlopen beheerderssessie. Meld u opnieuw aan.',
    // License
    'Entrez une clef valide pour activer votre licence.': 'Voer een geldige sleutel in om uw licentie te activeren.',
    'Non défini': 'Niet gedefinieerd',
    // LogFile
    'Toutes': 'Alle',
    'log(s) trouvé(s)': 'log(s) gevonden',
    'Administrateur': 'Beheerder',
    'Page': 'Pagina',
    'sur': 'van'
    ,
    // Examiner
    'Gestion des médecins légistes': 'Beheer van gerechtsartsen',
    'Modifier le médecin légiste': 'Gerechtsarts wijzigen',
    'Ajouter un médecin légiste': 'Gerechtsarts toevoegen',
    'Liste des médecins légistes': 'Lijst van gerechtsartsen',
    'Gestion des Annexes': 'Beheer van bijlagen',
    'Modifier l\'annexe': 'Bijlage wijzigen',
    'Ajouter une annexe': 'Bijlage toevoegen',
    'Liste des Annexes': 'Lijst van bijlagen',
    'Description': 'Beschrijving',
    'Aucune annexe trouvée': 'Geen bijlage gevonden',
    'Êtes-vous sûr de vouloir supprimer cette annexe ?': 'Weet u zeker dat u deze bijlage wilt verwijderen?',
    // Alert
    'Gestion des Alertes': 'Beheer van waarschuwingen',
    "Titre de l'alerte": 'Waarschuwingstitel',
    "Contenu de l'alerte": 'Waarschuwingsinhoud',
    "Icône de l'alerte": 'Waarschuwingspictogram',
    "Aperçu de l'alerte :": 'Voorbeeld van de waarschuwing:',
    'Alerte activée': 'Waarschuwing geactiveerd',
    'Alerte désactivée': 'Waarschuwing gedeactiveerd',
    "L'alerte sera visible pour tous les utilisateurs": 'De waarschuwing is zichtbaar voor alle gebruikers',
    "L'alerte ne sera pas affichée aux utilisateurs": 'De waarschuwing wordt niet weergegeven aan gebruikers',
    'Enregistrer': 'Opslaan',
    // Alert - icône labels
    'Temps et horaires': 'Tijd en uurregelingen',
    'Tâche accomplie': 'Taak voltooid',
    'Fermer ou refus': 'Sluiten of weigeren',
    'Attention': 'Opgelet',
    'Rapport': 'Rapport',
    'Information': 'Informatie',
    'Célébration': 'Viering',
    'Police': 'Politie',
    'Alerte': 'Waarschuwing',
    'Appréciation': 'Waardering',
    'Renseignements': 'Inlichtingen',
    'Maintenance': 'Onderhoud',
    'caractères': 'tekens',
    // RubricAdmin
    'Gestion des rubriques': 'Beheer van rubrieken',
    'Modifier la rubrique': 'Rubriek wijzigen',
    'Ajouter une rubrique': 'Rubriek toevoegen',
    'Rubriques de base': 'Basisrubrieken',
    'Rubriques judiciaires': 'Gerechtelijke rubrieken',
    'Rubriques accident et roulage': 'Rubrieken ongeval en verkeer',
    'Premières mesures': 'Eerste maatregelen',
    'Mesures secondaires': 'Secundaire maatregelen',
    'Banques de données': 'Databanken',
    'Constatations': 'Vaststellingen',
    'Privation de liberté': 'Vrijheidsberoving',
    'Audition': 'Verhoor',
    'Avis et contacts': 'Meldingen en contacten',
    'Requisitions': 'Vorderingen',
    'Enquête et recherches': 'Onderzoek en opsporing',
    'Rubriques de clôture': 'Afsluitende rubrieken',
    "Titre dans la liste d'ajout": 'Titel in de toevoeglijst',
    'Ajouter une option': 'Een optie toevoegen',
    'Type de rubrique': 'Type rubriek',
    'Générative': 'Generatief',
    'Manuelle': 'Handmatig',
    'L\'identifiant technique et le titre sont obligatoires.': 'Het technische ID en de titel zijn verplicht.',
    'Pour une rubrique manuelle, le titre et le contenu sont obligatoires.': 'Voor een handmatige rubriek zijn titel en inhoud verplicht.',
    'Veuillez sélectionner le fichier .js de la rubrique.': 'Selecteer het .js-bestand van de rubriek.',
    'Seuls les fichiers .js sont acceptés pour les rubriques génératives.': 'Alleen .js-bestanden zijn toegestaan voor generatieve rubrieken.',
    'Rubrique mise à jour avec succès.': 'Rubriek succesvol bijgewerkt.',
    'Rubrique ajoutée avec succès.': 'Rubriek succesvol toegevoegd.',
    'Rubrique supprimée avec succès.': 'Rubriek succesvol verwijderd.',
    'Erreur lors du chargement des rubriques.': 'Fout bij het laden van de rubrieken.',
    'Erreur lors de l\'enregistrement de la rubrique.': 'Fout bij het opslaan van de rubriek.',
    'Erreur lors du déplacement de la rubrique.': 'Fout bij het verplaatsen van de rubriek.',
    'Erreur lors de la modification du statut de la rubrique.': 'Fout bij het wijzigen van de status van de rubriek.',
    'Erreur lors de la suppression de la rubrique.': 'Fout bij het verwijderen van de rubriek.',
    'Erreur lors de la suppression': 'Fout bij het verwijderen',
    'Masquée': 'Verborgen',
    'Canevas': 'Sjabloon',
    'Afficher': 'Tonen',
    'Masquer': 'Verbergen',
    'Désactivez le tri pour réordonner': 'Schakel sortering uit om opnieuw te ordenen',
    'Déplacer vers le haut': 'Omhoog verplaatsen',
    'Déplacer vers le bas': 'Omlaag verplaatsen',
    'Sélectionnez le fichier .js de la rubrique. Il sera enregistré automatiquement dans le bon dossier selon la langue, avec le nom de l\'identifiant technique.': 'Selecteer het .js-bestand van de rubriek. Het wordt automatisch opgeslagen in de juiste map volgens de taal, met de naam van het technische ID.',
    'Fichier sélectionné': 'Bestand geselecteerd',
    'Choisir un fichier .js': 'Een .js-bestand kiezen',
    "Cette rubrique fait exclusivement partie d'un ou de plusieurs canevas et ne doit être accessible que par ces canevas (Ne sera pas visible dans la liste générale)": 'Deze rubriek maakt uitsluitend deel uit van een of meerdere sjablonen en mag alleen via die sjablonen toegankelijk zijn (Niet zichtbaar in de algemene lijst)',
    'Après avoir ajouté la rubrique dans cette liste, ajoutez le fichier correspondant dans ./rubrics.': 'Na het toevoegen van de rubriek aan deze lijst, voegt u het bijbehorende bestand toe in ./rubrics.',
    'Titre de la rubrique après ajout': 'Rubriekstitel na toevoegen',
    'Écrivez ici le contenu de la rubrique...': 'Schrijf hier de inhoud van de rubriek...',
    'Ce champ est obligatoire': 'Dit veld is verplicht',
    'Ce champ est obligatoire pour une rubrique manuelle': 'Dit veld is verplicht voor een handmatige rubriek',
    // Grades traductions
    'Aspirant Agent de Police': 'Aspirant-agent van politie',
    'Agent de Police': 'Agent van politie',
    'Premier Agent de Police': 'Eerste agent van politie',
    'Aspirant Agent de sécurisation de Police': 'Aspirant-beveiligingsagent van politie',
    'Agent de sécurisation de Police': 'Beveiligingsagent van politie',
    'Premier Agent de sécurisation de Police': 'Eerste beveiligingsagent van politie',
    'Aspirant Assistant de Sécurisation de Police': 'Aspirant-beveiligingsassistent van politie',
    'Assistant de Sécurisation de Police': 'Beveiligingsassistent van politie',
    'Premier Assistant de Sécurisation de Police': 'Eerste beveiligingsassistent van politie',
    'Coordonnateur de Sécurisation de Police': 'Beveiligingscoördinator van politie',
    'Premier Coordonnateur de Sécurisation de Police': 'Eerste beveiligingscoördinator van politie',
    'Aspirant Inspecteur de Police': 'Aspirant-inspecteur van politie',
    'Inspecteur de Police': 'Inspecteur van politie',
    'Premier Inspecteur de Police': 'Eerste inspecteur van politie',
    'Aspirant Inspecteur Principal de Police': 'Aspirant-hoofdinspecteur van politie',
    'Inspecteur Principal de Police': 'Hoofdinspecteur van politie',
    'Premier Inspecteur Principal de Police': 'Eerste hoofdinspecteur van politie',
    'Aspirant Commissaire de Police': 'Aspirant-commissaris van politie',
    'Commissaire de Police': 'Commissaris van politie',
    'Premier Commissaire de Police': 'Eerste commissaris van politie',
    'Commissaire Divisionnaire de Police': 'Hoofdcommissaris van politie',
    'Premier Commissaire Divisionnaire de Police': 'Eerste hoofdcommissaris van politie'
  }
}

function formatString(template, params) {
  if (!params) return template
  return Object.keys(params).reduce((acc, key) => acc.replaceAll(`{${key}}`, String(params[key])), template)
}

export function AdminLanguageProvider({ children }) {
  const [lang, setLang] = useState('FR')

  const value = useMemo(() => ({
    lang,
    setLang,
    t: (key, params) => {
      const dict = TRANSLATIONS[lang] || TRANSLATIONS.FR
      const template = dict[key] || key
      return typeof template === 'string' ? formatString(template, params) : template
    }
  }), [lang])

  return (
    <AdminLanguageContext.Provider value={value}>
      {children}
    </AdminLanguageContext.Provider>
  )
}

export function useAdminLanguage() {
  return useContext(AdminLanguageContext)
}


